
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fleet-success",
      function () {
        return require("private-next-pages/fleet-success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fleet-success"])
      });
    }
  